export { default } from './CompareMobile';
